export default "__VITE_ASSET__a49548c8__"